// "Before <month>": the pages that pick a period set the months before the Jira conventions started apart
// from the rest. The day itself is a setting (GET /config/boundaries); this is the pure reading of it.

export interface Boundary {
  /** "2026-07-01" */
  day: string;
  /** "2026-07" */
  month: string;
  /** "2026-Q3" */
  quarter: string;
}

/** A period written "2026-06", "2026-Q2" (the address) or "2026-2" (what the quarter picker holds), or "2026". */
export function isBeforeBoundary(period: string | null, boundary: Boundary | null): boolean {
  if (!period || !boundary) return false;
  if (/^\d{4}-(0[1-9]|1[0-2])$/.test(period)) return period < boundary.month;
  const q = /^(\d{4})-Q?([1-4])$/.exec(period);
  if (q) return `${q[1]}-Q${q[2]}` < boundary.quarter;
  if (/^\d{4}$/.test(period)) return Number(period) < Number(boundary.month.slice(0, 4));
  return false;
}

const PAGES_BY_MONTH = ['/reports', '/hygiene', '/flow', '/effort', '/compliance', '/my-audit', '/report', '/my-people'];

/**
 * The period a page is showing, read from its address: the month in ?period=, the quarter in ?quarter=
 * (Planning), and on Epic reports the one the open report uses. null when the page has no period, or shows
 * the current one (the default is left out of the address, and the current period is never "before").
 */
export function periodShown(pathname: string, params: URLSearchParams): string | null {
  if (PAGES_BY_MONTH.includes(pathname)) return params.get('period');
  if (pathname === '/planning') return params.get('quarter');
  // The Plan reads a month on its Intake tab and a quarter on the others (Before has no period).
  if (pathname === '/plan') return params.get('tab') === 'intake' ? params.get('period') : params.get('tab') === 'before' ? null : params.get('quarter');
  if (pathname === '/reports-overview') {
    const report = params.get('report');
    if (report === 'quarterly') return params.get('quarter');
    if (report === 'yearly') return params.get('year');
    return params.get('period');
  }
  return null;
}
